import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericDocument } from './document.interface';
import { SpvDocumentsService } from './spv/spv-documents.service';
import { TasDocumentsService } from './tas/tas-documents.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentsService {
  private spvNewSources = ['new.seguroparaviaje.com', 'seguroparaviaje.cr'];

  constructor(private _spv: SpvDocumentsService, private _tas: TasDocumentsService) {}

  searchDocumentsCompanySPV(body: number, source: string, birthDate: string): Observable<GenericDocument> {
    return this.spvNewSources.find((s) => source.includes(s))
      ? this._spv.search(body)
      : this._spv.searchOld(body, birthDate.split('T', 1).toString());
  }

  searchDocumentsCompanyTAS(body: any): Observable<GenericDocument> {
    return this._tas.search(body);
  }
}
